import { render } from "./MediaDisplay.vue?vue&type=template&id=5cdebc16&scoped=true&ts=true"
import script from "./MediaDisplay.vue?vue&type=script&lang=ts"
export * from "./MediaDisplay.vue?vue&type=script&lang=ts"

import "./MediaDisplay.vue?vue&type=style&index=0&id=5cdebc16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdebc16"]])

export default __exports__